const OOS_MECHANISM_LABELS = {
    UNSLOTTED_ITEM: 'Unslotted Item',
    PACK_LINE: 'Pack Line',
};

const OOS_STATUS_LABELS = {
    IN_STOCK: 'In Stock',
    OUT_OF_STOCK: 'Out of Stock',
};

/**
 * @param {string | null | undefined} oosType
 * @returns {string}
 */
export function getOosMechanismLabel(oosType) {
    if (!oosType) {
        return '—';
    }
    return OOS_MECHANISM_LABELS[oosType] ?? oosType;
}

/**
 * @param {string | null | undefined} status
 * @returns {string}
 */
export function getOosStatusLabel(status) {
    if (!status) {
        return '—';
    }
    return OOS_STATUS_LABELS[status] ?? status;
}

/**
 * @param {number | null | undefined} atsSnapshot
 * @returns {string}
 */
export function formatAtsSnapshot(atsSnapshot) {
    if (atsSnapshot === null || atsSnapshot === undefined) {
        return 'Unavailable';
    }
    return String(atsSnapshot);
}
